import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import Menu from './components/Menu/menu';
import VerLateral from './components/SolarFarm/Lateral/VerLateral';
import Arbol from './components/SolarFarm/Arbol/Arbol';
import Test from './components/Test/test';
import VerSolarFarm from './components/SolarFarm/VerSolarfarm';
import VerCt from './components/SolarFarm/CT/VerCt';
import VerInv from './components/SolarFarm/INV/VerInv';
import VerNCU from './components/SolarFarm/NCU/VerNCU';
import VerMeteo from './components/SolarFarm/Meteo/VerMeteo';
import VerAlarmas from './components/SolarFarm/Alarmas/VerAlarmas';
import VerComandos from './components/SolarFarm/Comandos/VerComandos';
import VerAnalizador from './components/SolarFarm/Analizador/VerAnalizador';
import VerPLC from './components/SolarFarm/PLC/VerPLC';
import VerSubestacion from './components/Subestacion/VerSubestacion';
import VerListaInv from './components/SolarFarm/ListaINV/VerListaInv';
import VerComparativas from './components/SolarFarm/Comparativas/VerComparativas';
import VerHistoricos from './components/SolarFarm/Historicos/VerHistoricos';
//import Loading from './components/Misc/Other/Loading';
import "bootstrap/dist/css/bootstrap.min.css";

import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey('e8884590cf36826a339063569cd966eeTz0xMDUzMTYsRT0xNzY5OTAzOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

var config;
function takeConfig() {
  config = sessionStorage.getItem("configuration");
}

function App() {
  takeConfig();

  if (!config) {
    return (
      <div id="div-app-login">
       {  /* <VerSubestacion/>*/}
      <Login />
      </div>
    )
  }

  /*Se encarga de las llamadas no se acumulen cuando cambias de pantalla */
  if(!sessionStorage.getItem("key")) {
    sessionStorage.setItem("key", 0);
  }

  return (
    <div id='div-app'>
      <div id="div-menu"><Menu/></div>
      <div id='div-lateral-izq'><VerLateral/></div>
      <div id='div-lateral-arbol'><Arbol/></div>
      <div id='div-centro-web'>
        <Router>
          <Routes>
            <Route exact path="*" element={<VerSolarFarm/>}/>
            <Route exact path="/" element={<VerSolarFarm/>}/>
            <Route exact path="/comandos" element={<VerComandos />} />
            <Route exact path="/alarmas" element={<VerAlarmas />} />
            <Route exact path="/meteo" element={<VerMeteo />} />
            <Route exact path="/analizador" element={<VerAnalizador />} />
            <Route exact path="/plc" element={<VerPLC />}/>
            <Route exact path="/substation" element={<VerSubestacion/>} />
            <Route exact path="/inv/:ct/:inv" element={<VerInv/>} />
            <Route exact path="/ncu/:ncu" element={<VerNCU/>} />
            <Route exact path="/ct/:ct" element={<VerCt/>}/>
            <Route exact path="/listaInv" element={<VerListaInv/>}/>
            <Route exact path="/Comparativas" element={<VerComparativas/>}/>
            <Route exact path="/Historicos" element={<VerHistoricos/>}/>
            <Route exact path="/test" element={<Test />} />
          </Routes>
        </Router>
      </div>    
    </div>
  );
}

export default App;
